import type { Student } from '@/lib/types';

type Props = {
  students: Student[];
  selectedIds: Set<string>;
  onToggle: (studentId: string) => void;
  emptyText?: string;
};

// 시간표 항목에 들어갈 학생을 체크박스로 넣고 빼는 공용 목록이에요.
export default function StudentRosterPicker({
  students,
  selectedIds,
  onToggle,
  emptyText = '등록된 학생이 없어요. 먼저 학생을 추가해 주세요.',
}: Props) {
  if (students.length === 0) {
    return (
      <p className="py-8 text-center text-sm text-foreground-400">{emptyText}</p>
    );
  }

  return (
    <div className="max-h-[260px] space-y-1 overflow-y-auto pr-1">
      {students.map((s) => {
        const checked = selectedIds.has(s.id);
        return (
          <label
            key={s.id}
            className="flex cursor-pointer items-center gap-3 rounded-md px-3 py-2 transition-colors hover:bg-background-50"
          >
            <input
              type="checkbox"
              checked={checked}
              onChange={() => onToggle(s.id)}
              className="h-4 w-4 cursor-pointer accent-primary-500"
            />
            <span className="flex h-7 w-7 items-center justify-center rounded-full bg-primary-100 text-xs font-bold text-primary-700">
              {s.name.charAt(0)}
            </span>
            <div className="min-w-0 flex-1">
              <span className="text-sm font-medium text-foreground-900">{s.name}</span>
              {s.grade && <span className="ml-2 text-xs text-foreground-500">{s.grade}</span>}
            </div>
            {s.school && (
              <span className="hidden text-xs text-foreground-400 sm:block">{s.school}</span>
            )}
          </label>
        );
      })}
    </div>
  );
}